export const STATUS_COLORS = {
  complete: { class: 'bg-green-100 text-green-800', label: 'Complete' },
  completed: { class: 'bg-green-100 text-green-800', label: 'Completed' },
  cancelled: { class: 'bg-red-100 text-red-800', label: 'Cancelled' },
  delivered: { class: 'bg-emerald-100 text-emerald-800', label: 'Delivered' },
  design: { class: 'bg-purple-100 text-purple-800', label: 'Design' },
  dispatched: { class: 'bg-teal-100 text-teal-800', label: 'Dispatched' },
  draft: { class: 'bg-slate-100 text-slate-700', label: 'Draft' },
  in_production: { class: 'bg-blue-100 text-blue-800', label: 'In Production' },
  in_progress: { class: 'bg-blue-100 text-blue-800', label: 'In Progress' },
  on_hold: { class: 'bg-red-100 text-red-800', label: 'On Hold' },
  pending: { class: 'bg-amber-100 text-amber-800', label: 'Pending' },
  ready: { class: 'bg-teal-100 text-teal-800', label: 'Ready' },
  ready_for_dispatch: { class: 'bg-green-100 text-green-800', label: 'Ready' },
  // where a replenishment run ends: the store, not a van
  ready_for_stock: { class: 'bg-amber-100 text-amber-800', label: 'To Stock' },
  stocked: { class: 'bg-slate-200 text-slate-700', label: 'In Stock' },
};

export const PRIORITY_COLORS = {
  low: { class: 'bg-green-50 text-green-700 border border-green-200', label: 'Low', dot: 'bg-green-500' },
  medium: { class: 'bg-yellow-50 text-yellow-700 border border-yellow-200', label: 'Medium', dot: 'bg-yellow-500' },
  high: { class: 'bg-red-50 text-red-700 border border-red-200', label: 'High', dot: 'bg-red-500' },
  urgent: { class: 'bg-red-100 text-red-700', label: 'Urgent', dot: 'bg-red-500' },
};

export const STATUS_MAP = STATUS_COLORS;
export const PRIORITY_MAP = PRIORITY_COLORS;
